export const urlTraceQueryKeys = {
  all: [{ scope: 'urlTrace' }] as const,
  trace: (traceId?: string) =>
    [{ ...urlTraceQueryKeys.all[0], traceId }] as const,
};
